import {
    IComponentController,
    IComponentOptions
} from 'angular';
import { IFontStyleModel, IVFInstance } from '../../../classes';
import template from './style-specimen-heading.html';

export class StyleHeadingComponentBindings {
    // style to show the heading for.
    font?: IFontStyleModel;
    // if variable, selected instance to display in heading.
    instance?: IVFInstance;
    // overrides the automatically selected style name, used on the style detail page when showing multiple px sizes.
    label?: string;
    labelOnly = false;
    // show the buy/save buttons.
    showBuyButton = false;
    showSaveButton = false;
    showTrialButton = false;

    onLabelClicked?: (args: { $event: Event; style: IFontStyleModel }) => void =
        undefined;
}

export class StyleSpecimenHeadingComponent
    extends StyleHeadingComponentBindings
    implements IComponentController
{
    // $onChanges(changes: IOnChangesObject): void {
    //     console.log('StyleHeadingComponent.$onChanges', changes);
    // }

    labelClicked($event: Event): void {
        $event.preventDefault();
        this.onLabelClicked &&
            this.font &&
            this.onLabelClicked({ $event, style: this.font });
    }
}

export const StyleSpecimenHeadingComponentOptions: IComponentOptions = {
    controller: StyleSpecimenHeadingComponent,
    bindings: {
        font: '<',
        instance: '<',
        label: '<',
        showBuyButton: '<',
        showSaveButton: '<',
        showTrialButton: '<',
        // add ? so angular won't set a defaul noop handler so we can test whether to display the last > in the label indicating
        // the label is an interactive component.
        onLabelClicked: '&?',
        labelOnly: '<',
    },
    template,
};
